import React from 'react';

import UtilityBar from '@common/components/app-layout/utility-bar/utility-bar';

import UtilityHeaderHelpMenu from './utility-bar-help-menu';

const AwareUtilityBar = () => (
  <UtilityBar applicationName="Aware" UtilityHeaderHelpMenu={UtilityHeaderHelpMenu} />
);

export default AwareUtilityBar;
